<template>
  <footer class="footer-footer1 thq-section-padding">
    <div class="footer-max-width thq-section-max-width">
      <div class="footer-content">
        <div class="footer-newsletter">
          <img :alt="imageAlt" :src="imageSrc" class="footer-image" />
          <span class="footer-content1 thq-body-small">
            Subscribe to our newsletter for the latest updates on new features and
            product highlights.
          </span>
          <div class="footer-actions"><subscribe-form></subscribe-form></div>
        </div>
        <div class="footer-links">
          <div class="footer-column1">
            <strong class="footer-column1-title thq-body-large">
              Navigation
            </strong>
            <div class="footer-footer-links">
              <router-link to="/" class="footer-link1 thq-body-small">
                Home
              </router-link>
              <router-link to="/about-us" class="footer-link101 thq-body-small">
                About Yubaro
              </router-link>
              <a
                href="https://medium.com/yubaro/"
                target="_blank"
                rel="noreferrer noopener"
                class="footer-link102 thq-body-small"
              >
                News/Webinars
              </a>
              <router-link to="/download" class="footer-link103 thq-body-small">
                Download
              </router-link>
              <router-link to="/contact" class="footer-link104 thq-body-small">
                Contact
                <span v-html="rawwkty"></span>
              </router-link>
            </div>
          </div>
          <div class="footer-column2">
            <strong class="footer-column2-title thq-body-large">
              {{ column2Title }}
            </strong>
            <div class="footer-footer-links1">
              <a
                href="https://apps.apple.com/us/app/yubaro/id6502051801"
                target="_blank"
                rel="noreferrer noopener"
                class="footer-link105 thq-body-small"
              >
                {{ link6 }}
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.yubaro.clientapp"
                target="_blank"
                rel="noreferrer noopener"
                class="footer-link106 thq-body-small"
              >
                {{ link7 }}
              </a>
              <router-link
                to="/terms-and-conditions"
                class="footer-link107 thq-body-small"
              >
                {{ link8 }}
              </router-link>
              <router-link
                to="/privacy-policy"
                class="footer-link108 thq-body-small"
              >
                Privacy Policy
              </router-link>
              <router-link
                to="/view-cookies"
                class="footer-link109 thq-body-small"
              >
                Cookie Policy
              </router-link>
            </div>
          </div>
          <div class="footer-column3">
            <strong class="footer-social-link1-title thq-body-large">
              {{ socialLinkTitleCategory }}
            </strong>
            <div class="footer-social-links">
              <a
                href="https://facebook.com/yubaro.io"
                target="_blank"
                rel="noreferrer noopener"
                class="footer-link"
              >
                <div class="footer-link01">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    class="footer-icon thq-icon-small"
                  >
                    <path
                      d="M713.143 73.143c90.857 0 164.571 73.714 164.571 164.571v548.571c0 90.857-73.714 164.571-164.571 164.571h-107.429v-340h113.714l17.143-132.571h-130.857v-84.571c0-38.286 10.286-64 65.714-64l69.714-0.571v-118.286c-12-1.714-53.714-5.143-101.714-5.143-101.143 0-170.857 61.714-170.857 174.857v97.714h-114.286v132.571h114.286v340h-304c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571z"
                    ></path>
                  </svg>
                  <span class="footer-social-link1 thq-body-small">Facebook</span>
                </div>
              </a>
              <a
                href="https://instagram.com/yubaro.io"
                target="_blank"
                rel="noreferrer noopener"
                class="footer-link02"
              >
                <div class="footer-link03">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    class="footer-icon02 thq-icon-small"
                  >
                    <path
                      d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"
                    ></path>
                  </svg>
                  <span class="footer-social-link2 thq-body-small">
                    Instagram
                  </span>
                </div>
              </a>
              <a
                href="https://twitter.com/yubaroio"
                target="_blank"
                rel="noreferrer noopener"
                class="footer-link04"
              >
                <div class="footer-link05">
                  <svg
                    viewBox="0 0 950.8571428571428 1024"
                    class="footer-icon04 thq-icon-small"
                  >
                    <path
                      d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"
                    ></path>
                  </svg>
                  <span class="footer-social-link3 thq-body-small">
                    Twitter/X
                  </span>
                </div>
              </a>
              <a
                href="https://linkedin.com/in/yubaro"
                target="_blank"
                rel="noreferrer noopener"
                class="footer-link06"
              >
                <div class="footer-link07">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    class="footer-icon06 thq-icon-small"
                  >
                    <path
                      d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"
                    ></path>
                  </svg>
                  <span class="footer-social-link4 thq-body-small">LinkedIn</span>
                </div>
              </a>
              <a
                href="http://youtube.com/@Yubaro"
                target="_blank"
                rel="noreferrer noopener"
                class="footer-link08"
              >
                <div class="footer-link09">
                  <svg
                    viewBox="0 0 1024 1024"
                    class="footer-icon08 thq-icon-small"
                  >
                    <path
                      d="M406.286 644.571l276.571-142.857-276.571-144.571v287.429zM512 152c215.429 0 358.286 10.286 358.286 10.286 20 2.286 64 2.286 102.857 43.429 0 0 31.429 30.857 40.571 101.714 10.857 82.857 10.286 165.714 10.286 165.714v77.714s0.571 82.857-10.286 165.714c-9.143 70.286-40.571 101.714-40.571 101.714-38.857 40.571-82.857 40.571-102.857 42.857 0 0-142.857 10.857-358.286 10.857v0c-266.286-2.286-348-10.286-348-10.286-22.857-4-74.286-2.857-113.143-43.429 0 0-31.429-31.429-40.571-101.714-10.857-82.857-10.286-165.714-10.286-165.714v-77.714s-0.571-82.857 10.286-165.714c9.143-70.857 40.571-101.714 40.571-101.714 38.857-41.143 82.857-41.143 102.857-43.429 0 0 142.857-10.286 358.286-10.286v0z"
                    ></path>
                  </svg>
                  <span class="footer-social-link5 thq-body-small">Youtube</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-credits">
        <div class="footer-divider thq-divider-horizontal"></div>
        <router-link
          to="/capital-risk-disclosure"
          class="footer-content2 thq-body-small"
        >
          <span>Your Capital is at Risk. Click here to read more.</span>
          <br />
        </router-link>
        <span class="footer-content21 thq-body-small">
          <span>© 2024 WealthExpress Limited. All Rights Reserved</span>
          <br />
          <span>Yubaro is a trading name of WealthExpress Limited.</span>
          <br />
        </span>
      </div>
    </div>
  </footer>
</template>

<script>
import SubscribeForm from './subscribe-form'

export default {
  name: 'Footer',
  props: {
    socialLinkTitleCategory: {
      type: String,
      default: 'Connect with us',
    },
    column2Title: {
      type: String,
      default: 'Resources',
    },
    link7: {
      type: String,
      default: 'Google Play Store',
    },
    imageSrc: {
      type: String,
      default: '/logo-tagline-blacktext-200h.webp',
    },
    link6: {
      type: String,
      default: 'Apple App Store',
    },
    imageAlt: {
      type: String,
      default: 'image',
    },
    link8: {
      type: String,
      default: 'Terms and Conditions',
    },
  },
  components: {
    SubscribeForm,
  },
  data() {
    return {
      rawwkty: ' ',
    }
  },
}
</script>

<style scoped>
.footer-footer1 {
  width: 100%;
  height: auto;
  display: flex;
  overflow: hidden;
  position: relative;
  align-items: center;
  flex-shrink: 0;
  padding-top: var(--dl-space-space-twounits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-twounits);
  justify-content: center;
}
.footer-max-width {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.footer-content {
  gap: var(--dl-space-space-fourunits);
  width: 100%;
  display: flex;
  align-self: stretch;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: var(--dl-radius-radius-radius4);
}
.footer-newsletter {
  gap: 24px;
  width: auto;
  display: flex;
  align-items: flex-start;
  flex-shrink: 0;
  flex-direction: column;
}
.footer-image {
  width: 139px;
  height: 56px;
  object-fit: cover;
}
.footer-content1 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  font-family: "Poppins";
}
.footer-actions {
  gap: 16px;
  width: 100%;
  display: flex;
  align-self: stretch;
  align-items: flex-start;
  flex-direction: column;
}
.footer-links {
  gap: var(--dl-space-space-twounits);
  width: 100%;
  display: flex;
  flex-grow: 1;
  align-items: flex-start;
  justify-content: flex-end;
}
.footer-column1 {
  gap: var(--dl-space-space-unit);
  width: auto;
  display: flex;
  overflow: hidden;
  flex-grow: 1;
  max-width: 300px;
  align-items: center;
  flex-shrink: 0;
  flex-direction: column;
}
.footer-column1-title {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  width: 100%;
  text-align: center;
  font-family: "Poppins";
}
.footer-footer-links {
  gap: var(--dl-space-space-unit);
  display: flex;
  align-self: stretch;
  align-items: center;
  flex-direction: column;
}
.footer-link1 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  width: 100%;
  padding: 0!important;
  margin-top: 0px;
  text-align: center;
  font-family: "Poppins";
  margin-left: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  text-decoration: none;
}
.footer-link101 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  width: 100%;
  padding: 0px;
  text-align: center;
  font-family: "Poppins";
  text-decoration: none;
}
.footer-link102 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  width: 100%;
  padding: 0px;
  text-align: center;
  font-family: "Poppins";
  text-decoration: none;
}
.footer-link103 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  width: 100%;
  text-align: center;
  font-family: "Poppins";
  padding-top: 0px;
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  text-decoration: none;
}
.footer-link104 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  width: 100%;
  padding: 0px;
  text-align: center;
  font-family: "Poppins";
  text-decoration: none;
}
.footer-column2 {
  gap: var(--dl-space-space-unit);
  width: auto;
  display: flex;
  overflow: hidden;
  flex-grow: 1;
  max-width: 300px;
  align-items: center;
  flex-shrink: 0;
  flex-direction: column;
}
.footer-column2-title {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  font-family: "Poppins";
}
.footer-footer-links1 {
  gap: var(--dl-space-space-unit);
  display: flex;
  align-self: stretch;
  align-items: center;
  flex-direction: column;
}
.footer-link105 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  width: 100%;
  text-align: center;
  font-family: "Poppins";
}
.footer-link106 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  width: 100%;
  text-align: center;
  font-family: "Poppins";
}
.footer-link107 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  width: 100%;
  text-align: center;
  font-family: "Poppins";
  text-decoration: none;
}
.footer-link108 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  width: 100%;
  text-align: center;
  font-family: "Poppins";
  text-decoration: none;
}
.footer-link109 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  width: 100%;
  text-align: center;
  font-family: "Poppins";
  text-decoration: none;
}
.footer-column3 {
  gap: var(--dl-space-space-unit);
  width: auto;
  display: flex;
  overflow: hidden;
  flex-grow: 1;
  max-width: 300px;
  align-items: flex-start;
  flex-shrink: 0;
  flex-direction: column;
}
.footer-social-link1-title {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  width: 100%;
  text-align: center;
  font-family: "Poppins";
}
.footer-social-links {
  gap: var(--dl-space-space-unit);
  display: flex;
  align-self: stretch;
  align-items: flex-start;
  flex-direction: column;
}
.footer-link {
  display: contents;
}
.footer-link01 {
  gap: 12px;
  display: flex;
  align-self: stretch;
  align-items: center;
  flex-shrink: 0;
  padding-top: 0px;
  padding-left: 8px 0;
  padding-right: 8px 0;
  padding-bottom: 0px;
  justify-content: center;
  text-decoration: none;
}
.footer-icon {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
}
.footer-social-link1 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  font-family: "Poppins";
}
.footer-link02 {
  display: contents;
}
.footer-link03 {
  gap: 12px;
  display: flex;
  align-self: stretch;
  align-items: center;
  flex-shrink: 0;
  padding-top: 0px;
  padding-left: 8px 0;
  padding-right: 8px 0;
  padding-bottom: 0px;
  justify-content: center;
  text-decoration: none;
}
.footer-icon02 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
}
.footer-social-link2 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  font-family: "Poppins";
}
.footer-link04 {
  display: contents;
}
.footer-link05 {
  gap: 12px;
  display: flex;
  align-self: stretch;
  align-items: center;
  flex-shrink: 0;
  padding-top: 0px;
  padding-left: 8px 0;
  padding-right: 8px 0;
  padding-bottom: 0px;
  justify-content: center;
  text-decoration: none;
}
.footer-icon04 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  border-radius: var(--dl-radius-radius-radius4);
}
.footer-social-link3 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  font-family: "Poppins";
}
.footer-link06 {
  display: contents;
}
.footer-link07 {
  gap: 12px;
  display: flex;
  align-self: stretch;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  text-decoration: none;
}
.footer-icon06 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
}
.footer-social-link4 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  font-family: "Poppins";
}
.footer-link08 {
  display: contents;
}
.footer-link09 {
  gap: 12px;
  display: flex;
  align-self: stretch;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  text-decoration: none;
}
.footer-icon08 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
}
.footer-social-link5 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  font-family: "Poppins";
}
.footer-credits {
  gap: var(--dl-space-space-unit);
  width: 100%;
  display: flex;
  align-self: stretch;
  margin-top: var(--dl-space-space-unit);
  align-items: flex-start;
  flex-direction: column;
}
.footer-divider {
  border-color: var(--dl-color-yubarobrandcolours-primarytext);
  border-style: dashed;
  border-width: 2px;
  background-color: var(--dl-color-yubarobrandcolours-primarytext);
}
.footer-content2 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  height: auto;
  font-size: 16px;
  align-self: stretch;
  font-style: Regular;
  text-align: left;
  font-family: "Poppins";
  font-weight: bold;
  line-height: 150%;
  font-stretch: normal;
  text-decoration: none;
}
.footer-content21 {
  fill: var(--dl-color-yubarobrandcolours-primarytext);
  color: var(--dl-color-yubarobrandcolours-primarytext);
  height: auto;
  font-size: 12px;
  align-self: stretch;
  font-style: Regular;
  text-align: left;
  font-family: "Poppins";
  font-weight: 400;
  line-height: 150%;
  font-stretch: normal;
  text-decoration: none;
}
@media(max-width: 1600px) {
  .footer-newsletter {
    width: 50%;
  }
  .footer-links {
    gap: 0;
    flex: 1;
    width: 50%;
    justify-content: space-between;
  }
}
@media(max-width: 1200px) {
  .footer-newsletter {
    gap: 0;
    width: 40%;
    margin-right: 0px;
  }
  .footer-actions {
    margin-top: var(--dl-space-space-halfunit);
  }
  .footer-links {
    width: 60%;
    height: auto;
  }
  .footer-link103 {
    padding-top: 0px;
    padding-left: 0px;
    padding-right: 0px;
    padding-bottom: 0px;
  }
}
@media(max-width: 991px) {
  .footer-footer1 {
    align-items: center;
    flex-direction: row;
    justify-content: center;
  }
  .footer-content {
    gap: var(--dl-space-space-twounits);
  }
  .footer-newsletter {
    width: 35%;
  }
  .footer-actions {
    margin-top: var(--dl-space-space-halfunit);
  }
  .footer-links {
    width: 65%;
  }
  .footer-credits {
    gap: var(--dl-space-space-unit);
  }
  .footer-divider {
    border-color: var(--dl-color-yubarobrandcolours-primarytext);
    background-color: var(--dl-color-yubarobrandcolours-primarytext);
  }
}
@media(max-width: 767px) {
  .footer-content {
    gap: var(--dl-space-space-twounits);
    flex-direction: column;
  }
  .footer-newsletter {
    width: 100%;
  }
  .footer-image {
    align-self: center;
  }
  .footer-content1 {
    text-align: center;
  }
  .footer-actions {
    margin-top: var(--dl-space-space-halfunit);
  }
  .footer-links {
    width: 100%;
    align-items: flex-start;
    justify-content: center;
  }
  .footer-column1 {
    align-items: center;
  }
  .footer-column1-title {
    text-align: center;
  }
  .footer-footer-links {
    gap: var(--dl-space-space-unit);
    align-self: center;
    align-items: center;
  }
  .footer-link1 {
    text-align: center;
  }
  .footer-link101 {
    text-align: center;
  }
  .footer-link102 {
    text-align: center;
  }
  .footer-link103 {
    text-align: center;
  }
  .footer-link104 {
    text-align: center;
  }
  .footer-column2 {
    align-items: center;
  }
  .footer-column2-title {
    text-align: center;
  }
  .footer-footer-links1 {
    gap: var(--dl-space-space-unit);
    align-self: center;
    align-items: center;
  }
  .footer-link105 {
    text-align: center;
  }
  .footer-link106 {
    text-align: center;
  }
  .footer-link107 {
    text-align: center;
  }
  .footer-link108 {
    text-align: center;
  }
  .footer-link109 {
    text-align: center;
  }
  .footer-column3 {
    align-items: center;
  }
  .footer-social-link1-title {
    text-align: center;
  }
  .footer-social-links {
    align-self: center;
  }
  .footer-content2 {
    text-align: center;
  }
  .footer-content21 {
    text-align: center;
  }
}
@media(max-width: 479px) {
  .footer-content {
    gap: var(--dl-space-space-twounits);
  }
  .footer-image {
    align-self: center;
  }
  .footer-content1 {
    text-align: center;
  }
  .footer-actions {
    width: 100%;
    margin-top: var(--dl-space-space-halfunit);
  }
  .footer-links {
    gap: var(--dl-space-space-unit);
    align-items: center;
    flex-direction: column;
  }
  .footer-column1 {
    width: 100%;
    max-width: 100%;
    align-items: center;
    justify-content: center;
  }
  .footer-column1-title {
    width: 100%;
  }
  .footer-footer-links {
    gap: var(--dl-space-space-unit);
    width: 100%;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
  .footer-link1 {
    width: 100%;
    text-align: center;
  }
  .footer-link101 {
    width: 100%;
    text-align: center;
  }
  .footer-link102 {
    width: 100%;
    text-align: center;
  }
  .footer-link103 {
    width: 100%;
    text-align: center;
  }
  .footer-link104 {
    width: 100%;
    text-align: center;
  }
  .footer-column2 {
    width: 100%;
    max-width: 100%;
    align-items: center;
    justify-content: center;
  }
  .footer-column2-title {
    width: 100%;
  }
  .footer-footer-links1 {
    gap: var(--dl-space-space-unit);
    align-items: center;
    justify-content: center;
  }
  .footer-link105 {
    width: 100%;
    text-align: center;
  }
  .footer-link106 {
    width: 100%;
    text-align: center;
  }
  .footer-link107 {
    width: 100%;
    text-align: center;
  }
  .footer-link108 {
    width: 100%;
    text-align: center;
  }
  .footer-link109 {
    color: var(--dl-color-yubarobrandcolours-primarytext);
    width: 100%;
    text-align: center;
    font-family: Poppins;
    text-decoration: none;
  }
  .footer-column3 {
    width: 100%;
    max-width: 100%;
    align-items: center;
    justify-content: center;
  }
  .footer-social-links {
    align-items: center;
    justify-content: center;
  }
  .footer-link01 {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .footer-social-link1 {
    text-align: left;
  }
  .footer-link03 {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .footer-social-link2 {
    text-align: left;
  }
  .footer-link05 {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .footer-social-link3 {
    text-align: left;
  }
  .footer-link07 {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .footer-social-link4 {
    text-align: left;
  }
  .footer-link09 {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .footer-social-link5 {
    text-align: left;
  }
  .footer-credits {
    gap: 0;
  }
  .footer-divider {
    border-color: var(--dl-color-yubarobrandcolours-primarytext);
    background-color: var(--dl-color-yubarobrandcolours-primarytext);
  }
  .footer-content2 {
    color: var(--dl-color-theme-neutral-dark);
    font-size: 16px;
    margin-top: var(--dl-space-space-halfunit);
    text-align: center;
    font-weight: bold;
    line-height: 150%;
    text-decoration: none;
  }
  .footer-content21 {
    color: var(--dl-color-theme-neutral-dark);
    font-size: 12px;
    margin-top: var(--dl-space-space-halfunit);
    text-align: center;
    font-weight: 400;
    line-height: 150%;
    text-decoration: none;
  }
}
</style>
